<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.dealers') }}
            </label>
            <v-autocomplete
              v-model="localFilter.dealer"
              :loading="loadingDealers"
              :items="dealers"
              :search-input.sync="dealerSearch"
              item-text="asdb"
              item-value="asdb"
              :readonly="!business"
              :clearable="business"
              :placeholder="$t('common.type_to_search')"
              cache-items
              hide-no-data
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="select-block select-block_white">
            <label class="select-block__label">
              {{ $t('views.email_list.type') }}
            </label>
            <v-select
              v-model="localFilter.type"
              :items="Object.values(EventTypes)"
              :readonly="!business"
              :clearable="business"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="4">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.email_list.to') }}
            </label>
            <v-text-field
              v-model="localFilter.to"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'EmailsFilter',

  props: {
    isShown: {
      type: Boolean,
      default: () => false,
    },

    filter: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localFilter: {
        dealer: '',
        type: '',
        to: '',
      },

      dealers: [],
      loadingDealers: false,
      dealerSearch: '',

      EventTypes: {
        system: 'system',
        business: 'business',
      },
    };
  },

  computed: {
    ...mapState(['user']),
    ...mapGetters(['business']),
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },

    dealerSearch(value) {
      if (value && value !== this.localFilter.deaker) {
        this.getDealers(value);
      }
    },
  },

  methods: {
    init() {
      if (!this.business) {
        this.dealers = [{ asdb: this.user && this.user.asdb }];
      }
      this.localFilter = { ...this.filter };
    },

    async getDealers(str) {
      this.loadingDealers = true;

      const query = {
        asdb: { $regex: `.*${str}.*`, $options: 'i' },
      };

      try {
        const { data } = await this.$http.get('/dealers', {
          params: { query },
        });
        this.dealers = data.rows;
      } finally {
        this.loadingDealers = false;
      }
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },
  },
};
</script>
